import { useEffect, useState } from "react";
import { AuthPage, ThemedTitleV2 } from "@refinedev/antd";
import { XconsIcon } from "@/components/icon/XconsIcon";

export const LoginPage = () => {
  const [checkingToken, setCheckingToken] = useState(true);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("access_token");

    if (token) {
      localStorage.setItem("access_token", token);
      localStorage.removeItem("smartMenuName");
      localStorage.removeItem("smartMenuState");
      localStorage.removeItem("smartMenuType");

      window.history.replaceState({}, document.title, "/");
      window.location.reload(); // esto está bien
      return;
    }
    const existingToken = localStorage.getItem("access_token");
    if (existingToken && window.location.pathname === "/login") {
      window.location.replace("/");
    }
  }, []);

  return (
    <AuthPage
      type="login"
      registerLink={false}
      forgotPasswordLink={false}
      title={
        <ThemedTitleV2
          collapsed={false}
          text="xcons admin"
          icon={<XconsIcon />}
        />
      }
    />
  );
};
